const MobileAppPromotion = {
  Title: "MobileAppPromotion.Title",
  Body: "MobileAppPromotion.Body",
  Disclaimer: "MobileAppPromotion.Disclaimer",
  CloseButton: "MobileAppPromotion.CloseButton",
  ReadMoreButton: "MobileAppPromotion.ReadMoreButton",
  }
export default MobileAppPromotion;